import { SpamScenarioId } from 'owa-junkmail-configuration';
import { assertNever } from 'owa-assert';
import strings from 'owa-strings/owa-options-strings';

// Used to retrieve text placeholder given scenarioId
export function getSpamPlaceHolder(scenarioId: SpamScenarioId): string {
    switch (scenarioId) {
        case SpamScenarioId.BlockedSendersAndDomains:
            return strings.optionPlaceHolder_blockSenderDomain;
        case SpamScenarioId.SafeSendersAndDomains:
            return strings.optionPlaceholder_safeSenderDomain;
        case SpamScenarioId.SafeMailingLists:
            return strings.optionPlaceholder_safeMailingList;
        default:
            return assertNever(scenarioId);
    }
}

// Used to retrieve option description given scenarioId
export function getSpamDescription(scenarioId: SpamScenarioId): string {
    switch (scenarioId) {
        case SpamScenarioId.BlockedSendersAndDomains:
            return strings.options_junk_blockedSenderDomainDescription;
        case SpamScenarioId.SafeSendersAndDomains:
            return strings.options_junkEmail_safeSenders;
        case SpamScenarioId.SafeMailingLists:
            return strings.options_junkEmail_safeMailingLists;
        default:
            return assertNever(scenarioId);
    }
}
